"use client"

import { CustomerProvider } from "@/components/customer-context"
import { ThemeProvider } from "@/components/theme-provider"
import { LanguageProvider } from "@/lib/i18n/LanguageContext"
import { ConfigurationProvider } from "@/lib/i18n/ConfigurationContext"
import "@/lib/i18n/config"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <LanguageProvider>
        <ConfigurationProvider>
          <CustomerProvider>
            {children}
          </CustomerProvider>
        </ConfigurationProvider>
      </LanguageProvider>
    </ThemeProvider>
  )
}